export const AUTHORIZATION_PROBLEM = 'Проблемы с авторизацией?';
export const ADMINISTRATOR = 'Обратитесь к администратору ';
export const EMAIL = 'edu@fond-igra.ru';
export const LETTER_SENT = 'Письмо отправлено';
export const MESSAGE_TEXT_PASSWORD = 'Мы отправили письмо с ссылкой для восстановления пароля на ';
export const PASSWORD_PROBLEM = 'Проблемы с восстановлением пароля?';
export const MESSAGE_TEXT_EMAIL = 'Мы отправили письмо для подтверждения почтового адреса на ';
export const HELP_INFO = 'Если письмо не пришло, проверьте папку спам';
export const ADMIN_REG = 'или обратитесь к администратору ';
export const ERROR_LINK_EMAIL = 'Ссылка, по которой вы перешли, устарела!';
export const BACK_TO_LOGIN = 'Вернуться на страницу авторизации';
export const EMAIL_CONFIRM_SUCCESS = 'Email успешно подтвержден!';
export const ACCESS_DENIED = 'Доступ запрещëн';
